<template>
  <div style="height: 100%">
    <dashboard-loading v-if="loading" />
    <div v-show="!loading" style="height: 100%">
      <config-drawer />
      <v-fade-transition mode="out-in">
        <router-view />
      </v-fade-transition>
    </div>
  </div>
</template>

<script>
import { mapMutations, mapState } from 'vuex';

import ConfigDrawer from '../components/ConfigDrawer.vue';
import DashboardLoading from '../../../../dashboard-viewer/src/components/DashboardLoading.vue';

export default {
  name: 'DowntimeIndex',
  components: {
    ConfigDrawer,
    DashboardLoading,
  },
  data() {
    return {
      interval: null,
      timeInterval: null,
    };
  },
  async created() {
    this.setShowHeaderButtons(true);
  },
  beforeDestroy() {
    clearInterval(this.interval);
    clearInterval(this.timeInterval);
  },
  computed: {
    ...mapState('cellwiseDowntimeDashboard', ['loading']),
  },
  methods: {
    ...mapMutations('cellwiseDowntimeDashboard', ['setLoading']),
    ...mapMutations('helper', ['setShowHeaderButtons']),
  },
};
</script>
